app.directive('mixpanelTrack',['$mixpanel', '$parse', function($mixpanel, $parse) {
  return {
    link: function(scope, element, attrs) {
      element.on(attrs.mixpanelTrack, function(event) {
        const eventName = attrs.mixpanelEvent || 'Click';
        const eventData = scope.$eval(attrs.mixpanelData) || {};
        $mixpanel.track(eventName, eventData);
      });
    }
  };
}]);

